export function showToast(message, duration = 2000) {
  let flashDiv = document.querySelector("#flash");
  flashDiv.innerHTML = `<div data-alert="alert" class="fade in alert alert-info">${message}<a class="close" data-dismiss="alert" href="#">×</a></div`;
  setTimeout(() => {
    flashDiv.firstChild.classList.remove("in");
    flashDiv.innerHTML = "";
  }, duration);
}
